var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUserLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25 11.5C9.25 10.8096 9.80964 10.25 10.5 10.25H14.5C15.1904 10.25 15.75 10.8096 15.75 11.5V14.5C15.75 15.1904 15.1904 15.75 14.5 15.75H10.5C9.80964 15.75 9.25 15.1904 9.25 14.5V11.5ZM10.75 11.75V14.25H14.25V11.75H10.75Z",
    className: "icon-fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 8.5C12.0172 8.5 11.5 8.98456 11.5 9.75V11C11.5 11.2761 11.2761 11.5 11 11.5C10.7239 11.5 10.5 11.2761 10.5 11V9.75C10.5 8.58245 11.3259 7.5 12.5 7.5C13.6741 7.5 14.5 8.58245 14.5 9.75V11C14.5 11.2761 14.2761 11.5 14 11.5C13.7239 11.5 13.5 11.2761 13.5 11V9.75C13.5 8.98456 12.9828 8.5 12.5 8.5Z",
    className: "icon-fill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 12.6667C1.25 10.7797 2.77969 9.25 4.66667 9.25H7.33333C7.74755 9.25 8.08333 9.58579 8.08333 10C8.08333 10.4142 7.74755 10.75 7.33333 10.75H4.66667C3.60812 10.75 2.75 11.6081 2.75 12.6667V13.3333C2.75 13.7475 2.41421 14.0833 2 14.0833C1.58579 14.0833 1.25 13.7475 1.25 13.3333V12.6667Z",
    className: "icon-fill"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33317 2.75C6.27462 2.75 5.4165 3.60812 5.4165 4.66667C5.4165 5.72521 6.27462 6.58333 7.33317 6.58333C8.39172 6.58333 9.24984 5.72521 9.24984 4.66667C9.24984 3.60812 8.39172 2.75 7.33317 2.75ZM3.9165 4.66667C3.9165 2.77969 5.4462 1.25 7.33317 1.25C9.22014 1.25 10.7498 2.77969 10.7498 4.66667C10.7498 6.55364 9.22014 8.08333 7.33317 8.08333C5.4462 8.08333 3.9165 6.55364 3.9165 4.66667Z",
    className: "icon-fill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserLock);
export default __webpack_public_path__ + "static/media/icon-user-lock.3a6c3c9984949ca4be81c9428bf8d337.svg";
export { ForwardRef as ReactComponent };